export const SET_HOTSPOT_DATA = "SET_HOTSPOT_DATA";
export const RESET_HOTSPOT_DATA = "RESET_HOTSPOT_DATA";
